var moment = require('moment');
angular.module('octopusApp.tasks').directive('taskStatus', taskStatus);

function taskStatus() {
  return {
    restrict: 'E',
    replace: true,
    transclude: false,
    scope: {
      task: "=",
      popDirection: "@",
      previousReleaseNumber: "=",
      previous: "=",
      archive: "="
    },
    templateUrl: 'areas/tasks/views/task-status.html',
    terminal: true,
    bindToController: true,
    controllerAs: 'vm',
    controller: function myController($scope, momentFromFilter) {
      var vm = this;
      vm.isAlert = false;
      vm.isSpinning = false;
      vm.icon = '';
      vm.tip = '';
      vm.title = '';
      vm.stateClass = '';

      $scope.$watch(function () {
        return $scope.vm.task;
      }, update);

      function update(task) {
        if (!task) {
          return;
        }
        vm.isAlert = isAlert(task);
        vm.isSpinning = isSpinning(task);
        vm.icon = getIcon(task);
        vm.tip = getTip(task);
        vm.title = getTitle(task);
        vm.stateClass = getStateClass(task);
      }

      function getStateClass(task) {
        if (task.HasPendingInterruptions && !task.IsCompleted) {
          return "Paused";
        }
        if (task.State === "Success" && task.HasWarningsOrErrors) {
          return "SuccessWithWarnings";
        }

        return task.State;
      }

      function getTitle(task) {
        if (vm.previousReleaseNumber) {
          return vm.previousReleaseNumber;
        }
        if (task.HasPendingInterruptions && !task.IsCompleted) {
          return "Waiting...";
        }

        if (task.State === "Queued") {
          return "Queued...";
        }

        if (task.State === "TimedOut") {
          return "Timed out";
        }
        return task.State;
      }

      function getTip(task) {
        var duration = task.Duration;
        var errorMessage = task.ErrorMessage;

        if (task.HasPendingInterruptions && !task.IsCompleted) {
          return "This task is waiting for manual intervention. Duration: " + duration;
        }
        if (task.State === "Cancelling") {
          return "Cancellation has been requested, attempting to stop the task.";
        }
        if (task.State === "Queued") {
          return (moment().isAfter(task.QueueTime) ? "This task was queued " : "This task has been scheduled to run ") + moment(task.QueueTime).fromNow();
        }
        if (task.State === "Executing") {
          return "This task is being executed by the Octopus Server. Duration: " + duration;
        }
        if (task.State === "Failed") {
          var tip = "An error occurred whilst processing this task";
          if (errorMessage && errorMessage.length > 0) {
            tip = tip + ": " + errorMessage;
          } else {
            tip = tip + ". See the task details for more information.";
          }
          return tip;
        }
        if (task.State === "Canceled") {
          return "This task was canceled by a user.";
        }
        if (task.State === "TimedOut") {
          var queueTime = moment(task.QueueTime).calendar();
          var expiryTime =  momentFromFilter(task.QueueTimeExpiry, task.QueueTime);
          var lastUpdated = moment(task.LastUpdatedTime).calendar();
          return "The task was scheduled to run " + queueTime + " within " + expiryTime + " but the Octopus Server attempted to run the task " + lastUpdated + ". This can happen when the Octopus server is too busy to process the task.";
        }

        if (task.State === "Success") {
          if (task.HasWarningsOrErrors) {
            return "This task completed successfully, but warnings or errors were reported in the log. Duration: " + duration;
          } else {
            return "This task completed without any problems. Duration: " + duration;
          }
        }

        return '';
      }

      function isSpinning(task) {
        return task.State === "Executing" && !task.HasPendingInterruptions;
      }

      function isAlert(task) {
        return task.State === "Success" && task.HasWarningsOrErrors;
      }

      function getIcon(task) {
        if (task.HasPendingInterruptions && !task.IsCompleted) {
          return "fa-eye";
        }
        return iconStateMap[task.State];
      }

      var iconStateMap = {
        "Cancelling": "fa-user-times",
        "Canceled": "fa-user-times",
        "Queued": "fa-clock-o",
        "TimedOut": "fa-clock-o",
        "Executing": "fa-spinner",
        "Failed": "fa-exclamation-triangle",
        "Success": "fa-check"
      };
    }
  };
}









//////////////////
// WEBPACK FOOTER
// ./app/areas/tasks/directives/task-status.js
// module id = 2556723586904029
// module chunks = 1